import { OwnAdministrativeFeeDto } from './ownadministrativefeedto';
import { PaginationFeaturesDto } from './paginationfeaturesdto';

export class OwnAdministrativeFeeRequest {

    ownAdministrativeFeeDto: OwnAdministrativeFeeDto = new OwnAdministrativeFeeDto();

    pageRequest: PaginationFeaturesDto = new PaginationFeaturesDto({});
}